<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100">
    <Testimonial3Content />
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import Testimonial3Content from "../components/OurTeam/Testimonial3Content.vue";

export default defineComponent({
  name: "Testimonial3Page",
  components: {
    MainNavbar,
    MainFooter,
    Testimonial3Content,
  },
});
</script>

<style scoped>
.testimonial-page {
  padding: 100px 20px 20px 20px;
}
</style>
